import Vue from 'vue';

const END_POINT = '/expenseCategory';

const getExpenseCategory = (id) => Vue.axios.get(END_POINT + '/' + id);

const getAllExpenseCategories = (data) =>
  Vue.axios.get(END_POINT, { params: data });

const createExpenseCategory = (expenseCategory) =>
  Vue.axios.post(END_POINT, expenseCategory);

const createAllExpenseCategories = (ExpenseCategories) =>
  Vue.axios.post(END_POINT + '/all', ExpenseCategories);

const updateExpenseCategory = (expenseCategory) =>
  Vue.axios.put(END_POINT + '/' + expenseCategory.id, expenseCategory);

const deleteExpenseCategory = (id) => Vue.axios.delete(END_POINT + '/' + id);

export {
  getExpenseCategory,
  getAllExpenseCategories,
  createExpenseCategory,
  createAllExpenseCategories,
  updateExpenseCategory,
  deleteExpenseCategory,
};
